import { AuthState } from './auth/types';
import { CartState } from './cart/types';
import { CheckoutState } from './checkout/types';
import { PaymentState } from './payment/types';
import { ContentState } from './content/types';
import { GeneralState } from './general/types';
import { MetaFlightState } from './metaFlight/types';
import { MyBookingState } from './myBooking/types';
import { MyBookingCredentialsState } from './myBookingCredentials/types';
import { MyBookingsState } from './myBookings/types';
import { MyBookingSessionState } from './myBookingSession/types';
import { PreCheckoutState } from './preCheckout/types';

export interface RootState extends RootModules {
    version: string;
}

interface RootModules {
    auth: AuthState;
    general: GeneralState;
    cart: CartState;
    checkout: CheckoutState;
    payment: PaymentState;
    content: ContentState;
    myBooking: MyBookingState;
    myBookingSession: MyBookingSessionState;
    myBookingCredentials: MyBookingCredentialsState;
    myBookings: MyBookingsState;
    preCheckout: PreCheckoutState;
    metaFlight: MetaFlightState;
}

export enum ReducerStatus {
    INITIAL = 'INITIAL',
    LOADING = 'LOADING',
    UPDATING = 'UPDATING',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
}
